export const FetchPurchaseOrderRequest= 'Fetch Purchase Order Request'
export const FetchPurchaseOrderSuccess= 'Fetch Purchase Order Success'
export const FetchPurchaseOrderFailure= 'Fetch Purchase Order Failure'
export const ClearTableData= 'Fetch Purchase Order Failure'